import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import bookingService from "../../services/booking.service";

export const initializeBooking = createAsyncThunk(
  "bookings/initialize",
  async (bookingData, { rejectWithValue }) => {
    try {
      console.log("$$$ booking data", bookingData);
      const response = await bookingService.createBookingInit(bookingData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to create booking" },
      );
    }
  },
);

export const createBooking = createAsyncThunk(
  "bookings/create",
  async (bookingData, { rejectWithValue }) => {
    try {
      const response = await bookingService.createBooking(bookingData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to create booking" },
      );
    }
  },
);

export const fetchMyBookings = createAsyncThunk(
  "bookings/fetchMy",
  async (params, { rejectWithValue }) => {
    try {
      const response = await bookingService.getMyBookings(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch bookings" },
      );
    }
  },
);

export const fetchBooking = createAsyncThunk(
  "bookings/fetchOne",
  async (id, { rejectWithValue }) => {
    try {
      const response = await bookingService.getBooking(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch booking" },
      );
    }
  },
);

export const cancelBooking = createAsyncThunk(
  "bookings/cancel",
  async ({ id, reason }, { rejectWithValue }) => {
    try {
      const response = await bookingService.cancelBooking(id, reason);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to cancel booking" },
      );
    }
  },
);

const bookingSlice = createSlice({
  name: "bookings",
  initialState: {
    bookings: [],
    currentBooking: null,
    pagination: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrentBooking: (state) => {
      state.currentBooking = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    setBookingDates: (state, action) => {
      state.bookingDates = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.currentBooking = action.payload.booking;
      })
      .addCase(createBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message;
      })
      .addCase(fetchMyBookings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = action.payload.bookings;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchMyBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message;
      })
      .addCase(fetchBooking.fulfilled, (state, action) => {
        state.currentBooking = action.payload.booking;
      })
      .addCase(cancelBooking.fulfilled, (state, action) => {
        const index = state.bookings.findIndex(
          (b) => b._id === action.payload.booking._id,
        );
        if (index !== -1) {
          state.bookings[index] = action.payload.booking;
        }
      });
  },
});

export const { clearCurrentBooking, clearError, setBookingDates } =
  bookingSlice.actions;
export default bookingSlice.reducer;
